import * as swcHelpers from '@swc/helpers';
import { PaymentFlow } from '@grandvisionhq/payments';
import { CLEAR_PAYMENT_FLOW, SET_PAYMENT_FLOW, UPDATE_PAYMENT_DETAILS, SELECT_PAYMENT_METHOD } from './actions.js';

const initialState = {
    paymentDetails: {},
    paymentFlow: PaymentFlow.UNDEFINED
};
function paymentReducer(state = initialState, action) {
    switch(action.type){
        case SELECT_PAYMENT_METHOD:
            return swcHelpers.objectSpread({}, state, {
                paymentDetails: {},
                selectedPaymentMethod: swcHelpers.objectSpread({}, action.payload)
            });
        case UPDATE_PAYMENT_DETAILS:
            const { type , provider , data , info , result , isValid  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                paymentDetails: swcHelpers.objectSpread({}, state.paymentDetails, {
                    [provider]: {
                        type,
                        data,
                        info,
                        result,
                        isValid
                    }
                })
            });
        case SET_PAYMENT_FLOW:
            return swcHelpers.objectSpread({}, state, {
                paymentFlow: action.payload.paymentFlow
            });
        case CLEAR_PAYMENT_FLOW:
            return swcHelpers.objectSpread({}, state, {
                paymentFlow: PaymentFlow.UNDEFINED
            });
        default:
            return state;
    }
}

export { paymentReducer as default, initialState };
//# sourceMappingURL=reducer.js.map
